import React from 'react'
import cx from 'classnames'
import MoreIcon from 'react-icons/lib/io/more'
import debounce from 'lodash/debounce'

import { makeModalAPI, Overlay } from './Modal'

import './DropdownMenu.css'

export const dropdownAPI = makeModalAPI('dropdown')

export const DropdownMenu = dropdownAPI(class DropdownMenu extends React.PureComponent {
  state = { top: 0, left: 0, tries: 0 }
  onRender = (el) => {
    if (!el || el === this.el) return
    this.el = el
  }

  onMenuRef = (el) => {
    if (!el || el === this.menuEl) return
    this.menuEl = el
  }

  getLeftTop = () => {
    if (!this.el) return {}
    const { dropdownValue } = this.props
    if (!dropdownValue || !dropdownValue.getBoundingClientRect) {
      return this.el.getBoundingClientRect()
    }

    const o = dropdownValue.getBoundingClientRect()
    return {
      left: o.left + (o.width / 2),
      top: o.top + (o.height / 2)
    }
  }

  updatePosition = () => {
    const { el, menuEl } = this
    if (!el || !menuEl) return
    let { top, left } = this.getLeftTop()
    let { height, width } = menuEl.getBoundingClientRect()
    if (el.classList.contains('right')) {
      left -= width
    }

    const buffer = 10
    const layout = {
      height: document.body.clientHeight - buffer,
      width: document.body.clientWidth - buffer
    }
    top = Math.max(0, Math.min(top, layout.height - height))
    left = Math.max(0, Math.min(left, layout.width - width))
    top = Math.round(top)
    left = Math.round(left)
    height = Math.round(height)
    width = Math.round(width)
    if (top !== this.state.top || left !== this.state.left) {
      this.setState({ top, left, tries: this.state.tries + 1 }, () => {
        if (this.state.tries < 5) this.updatePosition()
      })
    } else {
      this.setState({ tries: 0 })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.dropdownIsOpen) return
    this.updatePosition()
  }

  _resizeHandler = debounce(() => {
    if (!this.props.dropdownIsOpen) return
    this.updatePosition()
  }, 250, { leading: true, trailing: true })

  componentDidMount () {
    window.addEventListener('resize', this._resizeHandler)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this._resizeHandler)
  }

  render () {
    const {
      dropdownValue,
      dropdownOpen,
      dropdownClose,
      dropdownIsOpen,
      className,
      children,
      keepClick,
      ...props
    } = this.props
    return (
      <div
        className={cx('DropdownMenuContainer', className, dropdownIsOpen ? 'open' : 'closed')}
        {...props}
        ref={this.onRender}
      >
        {!dropdownIsOpen ? null : <Overlay onTrigger={dropdownClose} />}
        <div className='DropdownMenuInnerContainer'>
          <menu
            className={cx('DropdownMenu', className, dropdownIsOpen ? 'open' : 'closed')}
            ref={this.onMenuRef}
            style={{
              top: `${this.state.top}px`,
              left: `${this.state.left}px`
            }}
            onClickCapture={keepClick ? undefined : delay(() => dropdownClose())}
          >
            {!dropdownIsOpen ? null : children}
          </menu>
        </div>
      </div>
    )
  }
})

function delay (fn) {
  return (...args) => Promise.resolve().then(() => fn(...args))
}

export const MoreTrigger = dropdownAPI(({ dropdownOpen, Icon = MoreIcon }) => (
  <Icon
    className='Icon MoreTrigger'
    onClick={onTriggerClick(dropdownOpen)}
  />
))

export function onTriggerClick (fn) {
  return (event) => {
    const getBoundingClientRect = event.currentTarget.getBoundingClientRect.bind(event.currentTarget)
    fn({
      getBoundingClientRect
    })
  }
}

export const MoreMenu = dropdownAPI(({ dropdownOpen, dropdownIsOpen, className = '', name, children, Icon, ...props }) => (
  <div className={cx('MoreMenu', className, dropdownIsOpen ? 'open' : 'closed')}>
    <MoreTrigger name={name} Icon={Icon} />
    <DropdownMenu className={className.includes('left') ? 'left' : 'right'} name={name} children={children} {...props} />
  </div>
))

export default DropdownMenu

export {
  DropdownMenu as Menu,
  dropdownAPI as API
}



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.js